import { removeLeadingHashNumber } from "@/lib/utils";
import { ProductCategory } from "@/types/product";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { LinkArrow } from "../svgs";
import { Badge } from "../ui/badge";

export default function CategoryCard({
  product,
  index,
}: {
  product: ProductCategory;
  index: number;
}) {
  const isEven = (index + 1) % 2 === 0;

  return (
    <Link
      href={`/vara-provningar/${product.slug}`}
      aria-label={`Läs mer om ${
        product?.name && removeLeadingHashNumber(product.name)
      }`}
      // className="flex items-center gap-2 text-base hover:underline"
    >
      <div
        className={`group  ${
          isEven ? "bg-primary-pink" : "bg-primary-pink-light"
        }`}
      >
        <div className="relative w-full h-[330px]">
          {product.image?.mediaItemUrl && product.image?.altText ? (
            <Image
              src={product.image?.mediaItemUrl}
              alt={product.image?.altText}
              fill
              style={{
                objectFit: "cover",
              }}
            />
          ) : (
            <Image
              src="/placeholder.jpg"
              alt="Product category placeholder image"
              fill
              style={{
                objectFit: "cover",
              }}
            />
          )}
        </div>

        <div className="relative w-full h-40 p-8 flex flex-col gap-2">
          <Badge className="bg-primary-red absolute -top-3 left-5 text-primary-foreground">
            {product.categoryContent?.pris} kr
          </Badge>
          <h2 className="font-bold text-primary-red text-lg font-josefin">
            {product?.name && removeLeadingHashNumber(product.name)}
          </h2>
          <span className="flex items-center gap-2 text-base group-hover:underline text-primary-red">
            Läs mer & boka <LinkArrow />
          </span>
        </div>
      </div>
    </Link>
  );
}
